:host {
  display: contents;
}

.spw-table-cell {
  border: 1px solid var(--spw-color-themes-grey-grey-300);
  color: var(--spw-color-themes-grey-grey-800);
  font-size: 14px;
  text-align: left;
  padding: 16px;
  border-top: 0;
  &--is-highlighted {
    font-weight: 700;
    background: var(--spw-color-themes-grey-grey-100);
  }
  &--text-align-left {
    text-align: left;
  }
  &--text-align-center {
    text-align: center;
  }
  &--text-align-right {
    text-align: right;
  }
  &--vertical-align-top {
    vertical-align: top;
  }
  &--vertical-align-bottom {
    vertical-align: bottom;
  }
  &--vertical-align-middle {
    vertical-align: middle;
  }
}
